import { createContext, useContext, useMemo } from 'react'
import { useApiListAssetThumbnail, useApiListNodeLibrary } from '../../../../../api-new/state/content'
import { useLoad } from '../../../../../shared/hooks/load'
import { useFirstLoadSettled } from '../../../../../shared/empty-state/empty-state'
import { DATATYPE_NODE_LIBRARY, DATATYPE_NODE_LIBRARY_CATEGORY } from '../common/shared/metadata'

const DataContext = createContext()

export const useDataContext = () => useContext(DataContext)

export const DataProvider = ({ children }) => {
  const apiListNodeLibrary = useApiListNodeLibrary()
  const apiListAssetThumbnail = useApiListAssetThumbnail()

  useLoad(() => {
    apiListNodeLibrary.get()
    apiListAssetThumbnail.get('library')
  }, [])

  // True once the first fetch has answered, so the page can tell "still
  // loading" from "nothing here" (and reloads never flash a loading state).
  const loaded = useFirstLoadSettled(apiListNodeLibrary)

  const categories = useMemo(() => apiListNodeLibrary.items.filter(node => node.datatype === DATATYPE_NODE_LIBRARY_CATEGORY), [apiListNodeLibrary])
  const libraries = useMemo(() => apiListNodeLibrary.items.filter(node => node.datatype === DATATYPE_NODE_LIBRARY), [apiListNodeLibrary])

  return (
    <DataContext.Provider
      value={{
        reload: async () => {
          await apiListNodeLibrary.get()
          apiListAssetThumbnail.get('library')
        },

        loaded: loaded,
        error: apiListNodeLibrary.error,
        retry: () => apiListNodeLibrary.get(),
        items: apiListNodeLibrary.items,
        categories: categories,
        libraries: libraries,

        thumbnails: apiListAssetThumbnail.items
      }}>
      {children}
    </DataContext.Provider>
  )
}
